import { MonoWhiteDeck } from "../../../../src/data/articles/how-heirloom-blade-made-me-a-better-cube-designer/sample-decks/MonoWhiteDeck.tsx";
import { Izzet } from "../../../../src/data/articles/how-heirloom-blade-made-me-a-better-cube-designer/sample-decks/Izzet.tsx";
import * as React from 'react';
export default {
  MonoWhiteDeck,
  Izzet,
  React
};